export class UrlFilter<T, Setter = T> {
  urlKey: string;
  private _deserialize: (get?: string) => T;
  private _serialize: (value?: Setter) => string | undefined | null;
  private serializedValue?: string;

  constructor(key: string, getter: (get?: string) => T, setter: (value?: Setter) => string | undefined | null) {
    this.urlKey = key;
    this._deserialize = getter;
    this._serialize = setter;
  }

  serialize(value?: Setter) {
    return this._serialize(value);
  }
  deserialize(get?: string) {
    return this._deserialize(get);
  }
  persist(value?: Setter) {
    const serializedValue = this.serialize(value);

    if (serializedValue) {
      this.serializedValue = serializedValue;
    }
  }
  getPersistedValue(): string | undefined {
    return this.serializedValue;
  }
  clearPersistedValue() {
    this.serializedValue = undefined;
  }
}

export function createUrlFilter<T, Setter = T>(props: {
  key: string;
  deserialize: (get?: string) => T;
  serialize: (value?: Setter) => string | undefined | null;
}) {
  return new UrlFilter(props.key, props.deserialize, props.serialize);
}

export function createUrlObjectFilter<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any>,
  Setter = T,
>(keyString: string) {
  return new UrlFilter(
    keyString,
    (stringValue?: string): T | undefined => {
      if (!stringValue) {
        return;
      }
      try {
        return JSON.parse(decodeURIComponent(stringValue)) as T;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        return;
      }
    },
    (value?: Setter): string | undefined | null => {
      if (!value) {
        return;
      }
      return encodeURIComponent(JSON.stringify(value));
    },
  );
}

export function createUrlEnumFilter<T extends string | number, Setter = T>(
  keyString: string,
): UrlFilter<T | undefined, Setter>;
export function createUrlEnumFilter<T extends string | number, Setter = T>(
  keyString: string,
  defaultValue: T,
): UrlFilter<T, Setter>;
export function createUrlEnumFilter<T extends string | number, Setter = T>(keyString: string, defaultValue?: T) {
  return new UrlFilter(
    keyString,
    (stringValue?: string): T | undefined => {
      if (stringValue === undefined || stringValue === null) {
        return defaultValue;
      }
      return (isNaN(stringValue as unknown as number) ? stringValue : Number(stringValue)) as T;
    },
    (value?: Setter): string | null => {
      if (value === undefined || value === null) {
        return defaultValue as string;
      }
      return value.toString();
    },
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createFilters<T extends { [key: string]: UrlFilter<any, any> }>(filters: T): T {
  return filters;
}

type Callback<T> = (data: T) => void;

export class PubSub<T> {
  private subscriptions: Set<Callback<T>> = new Set();
  private data?: T;
  subscribe(callback: Callback<T>): () => void {
    this.subscriptions.add(callback);

    return () => {
      this.unsubscribe(callback);
    };
  }

  private unsubscribe(callback: Callback<T>): void {
    this.subscriptions.delete(callback);
  }

  publish(data: T): void {
    this.data = data;
    this.subscriptions.forEach((callback) => {
      callback(data);
    });
  }
  getValues() {
    return this.data;
  }
}

export const searchHistoryChangeStore = new PubSub<string>();

type PushStateType = typeof window.history.pushState;

// Create a proxy handler
const pushStateProxyHandler: ProxyHandler<PushStateType> = {
  apply: function (target, thisArg, args: [data: unknown, unused: string, url?: string | URL | null | undefined]) {
    // Apply your proxy logic here
    // You can modify the arguments if needed
    // For example, you can intercept the URL and modify it

    // Call the original pushState function
    const output = target.apply(thisArg, args);
    // const search = window.location.search;

    // if (search !== searchHistoryChangeStore.getValues()) {
    //   searchHistoryChangeStore.publish(window.location.search);
    // }
    searchHistoryChangeStore.publish(window.location.search);

    return output;
  },
};
type ReplaceStateType = typeof window.history.replaceState;
const replaceStateProxyHandler: ProxyHandler<ReplaceStateType> = {
  apply: function (target, thisArg, args: [data: unknown, unused: string, url?: string | URL | null | undefined]) {
    const output = target.apply(thisArg, args);
    // const search = window.location.search;

    searchHistoryChangeStore.publish(window.location.search);
    // if (search !== searchHistoryChangeStore.getValues()) {
    //   searchHistoryChangeStore.publish(window.location.search);
    // }

    return output;
  },
};

let isApplied = false;

export function setupProxy() {
  if (isApplied) return;
  {
    // Create a proxy for the pushState function
    const pushStateProxy = new Proxy(window.history.pushState, pushStateProxyHandler);

    const replaceStateProxy = new Proxy(window.history.replaceState, replaceStateProxyHandler);

    // Override the original pushState function with the wrapper
    window.history.pushState = pushStateProxy;
    window.history.replaceState = replaceStateProxy;

    isApplied = true;
  }
}
